module.exports = __webpack_public_path__ + "officialStatic/img/product-znyy.bfba9fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-znyy.png
// module id = kEnJ
// module chunks = 0